import { useMemo } from 'react';
import { useQueryClient } from 'react-query';
import { useSelector } from 'react-redux';
import { getQueryKeys } from '../queries/queryKeys';

const useHousingStockHousesState = () => {
  const queryClient = useQueryClient();

  const currentCompany = useSelector(
    (state) => state.housingStockStore.currentCompany
  );

  const housingStockHousesQueryKey = useMemo(
    () => getQueryKeys.housingStockHouses({ companyId: currentCompany?.id }),
    [currentCompany]
  );

  const housingStockHousesState = queryClient.getQueryState(
    housingStockHousesQueryKey
  );

  return { housingStockHousesQueryKey, housingStockHousesState };
};

export default useHousingStockHousesState;
